import { immerable, produce } from "immer"

export default class Immerable {
  [immerable] = true
}

export { produce }
